var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 132,
    viewBox: "0 0 107 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.2771 111.684H5.06604V131.997H101.405V111.684H91.2609H91.2771ZM96.3493 121.841V126.919H10.1382V116.763H96.3493V121.841Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.411 10.1578V15.236V20.3142V25.3923V30.4543V35.5325V40.6106V45.6888V50.767V55.8451V60.9233V66.0015V71.0797V76.1578V81.236V86.3142V91.3761V96.4543V101.532V106.611V111.689H106.483V106.611V101.532V96.4543V91.3761V86.3142V81.236V76.1578V71.0797V66.0015V60.9233V55.8451V50.767V45.6888V40.6106V35.5325V30.4543V25.3923V20.3142V15.236V10.1578H101.411Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.417 5.07892H96.3445V10.1571H101.417V5.07892Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2893 5.07817H25.3615H30.4337H35.4897H40.5618H45.634H50.7062H55.7784H60.8506H65.9228H70.995H76.0672H81.1394H86.2116H91.2838H96.3397V0H91.2838H86.2116H81.1394H76.0672H70.995H65.9228H60.8506H55.7784H50.7062H45.634H40.5618H35.4897H30.4337H25.3615H20.2893H15.2171H10.1449V5.07817H15.2171H20.2893Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1382 5.07892H5.06604V10.1571H10.1382V5.07892Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0722 101.532V96.4543V91.3761V86.3142V81.236V76.1578V71.0797V66.0015V60.9233V55.8451V50.767V45.6888V40.6106V35.5325V30.4543V25.3923V20.3142V15.236V10.1578H0V15.236V20.3142V25.3923V30.4543V35.5325V40.6106V45.6888V50.767V55.8451V60.9233V66.0015V71.0797V76.1578V81.236V86.3142V91.3761V96.4543V101.532V106.611V111.689H5.0722V106.611V101.532Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2109 91.3752V96.4534H20.2831H25.3553V91.3752H20.2831H15.2109Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1392 91.3752H76.067H70.9948H65.9227V96.4534H70.9948H76.067H81.1392H86.2114H91.2836V91.3752H86.2114H81.1392Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2125 20.3149V25.393V30.455V35.5332V40.6113V45.6895V50.7677V55.8458V60.924V66.0022H91.2847V60.924V55.8458V50.7677V45.6895V40.6113V35.5332V30.455V25.393V20.3149V15.2367H86.2125V20.3149Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4342 15.236H35.4902H40.5624H45.6346H50.7068H55.779H60.8512H65.9234H70.9956H76.0678H81.14H86.2121V10.1578H81.14H76.0678H70.9956H65.9234H60.8512H55.779H50.7068H45.6346H40.5624H35.4902H30.4342H25.3621H20.2899V15.236H25.3621H30.4342Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2831 55.8458V50.7677V45.6895V40.6113V35.5332V30.455V25.393V20.3149V15.2367H15.2109V20.3149V25.393V30.455V35.5332V40.6113V45.6895V50.7677V55.8458V60.924V66.0022H20.2831V60.924V55.8458Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0678 66H70.9956H65.9234H60.8512H55.779H50.7068H45.6346H40.5624H35.4902H30.4342H25.3621H20.2899V71.0782H25.3621H30.4342H35.4902H40.5624H45.6346H50.7068H55.779H60.8512H65.9234H70.9956H76.0678H81.14H86.2121V66H81.14H76.0678Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1071 25.3875V30.4657H48.1793H58.3236V38.0911H48.1793V48.2474H53.2514V43.1692H63.3958V25.3875H43.1071Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2453 53.3279H48.1731V58.4061H53.2453V53.3279Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.56f752a0.svg";
export { ForwardRef as ReactComponent };